/**
 * 相対日付のフィルター値 (文字列表現) をパースする
 * @param stringValue 例: `$NOW(1 days)`, `$NOW(-1 month)`
 * @returns { amount: number, type: string } | null
 */
export const parseRelativeDateFilterValue = (
  stringValue: string,
): {
  amount: number
  type: 'day' | 'week' | 'month' | 'year'
} | null => {
  if (typeof stringValue !== 'string' || !stringValue.startsWith('$NOW')) {
    return null
  }
  if (stringValue === '$NOW') {
    return { amount: 0, type: 'day' }
  }
  const REGEX_BETWEEN_PARENS = /\(([^)]+)\)/
  const adjustmentMatch = stringValue.match(REGEX_BETWEEN_PARENS)
  let adjustment = adjustmentMatch[1]
  const subtract = adjustment.startsWith('-')

  if (subtract || adjustment.startsWith('+')) {
    adjustment = adjustment.substring(1)
  }
  const match =
    /^(-?(?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|weeks?|w|months?|mth|mo|years?|yrs?|y)?$/i.exec(
      adjustment,
    )

  if (!match || !match[1]) {
    return null
  }
  const amount = parseFloat(match[1])
  const type = (match[2] ?? 'days').toLowerCase()
  return {
    amount: subtract ? -amount : amount,
    type: type as 'day' | 'week' | 'month' | 'year',
  }
}
